import React from 'react';
import PropTypes from 'prop-types';
import { useHref, useNavigate } from 'react-router';


// Minimal replacement for react-router-bootstrap's <LinkContainer>: makes the
// child element navigate to `to` on click (react-router-bootstrap does not
// support react-router 8).
const isModifiedEvent = event => !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

const LinkContainer = ({
  children,
  to,
  replace = false,
  state,
  onClick,
  ...rest
}) => {
  const navigate = useNavigate();
  const href = useHref(to);

  const handleClick = (event) => {
    if (children && children.props && children.props.onClick) {
      children.props.onClick(event);
    }
    if (onClick) {
      onClick(event);
    }
    if (event.defaultPrevented || event.button !== 0 || isModifiedEvent(event)) {
      return;
    }
    event.preventDefault();
    navigate(to, { replace, state });
  };

  if (!React.isValidElement(children)) {
    return (
      <button type="button" {...rest} onClick={handleClick}>
        {children}
      </button>
    );
  }

  const isAnchor = children.type === 'a';
  return React.cloneElement(children, {
    ...rest,
    ...(isAnchor ? { href } : {}),
    onClick: handleClick,
  });
};

LinkContainer.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  replace: PropTypes.bool,
  state: PropTypes.any,
  onClick: PropTypes.func,
};

export default LinkContainer;
